var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 4.00065C1.33337 3.29341 1.61433 2.61513 2.11442 2.11503C2.61452 1.61494 3.2928 1.33398 4.00004 1.33398H12C12.7073 1.33398 13.3856 1.61494 13.8857 2.11503C14.3858 2.61513 14.6667 3.29341 14.6667 4.00065V12.0007C14.6667 12.7079 14.3858 13.3862 13.8857 13.8863C13.3856 14.3864 12.7073 14.6673 12 14.6673H4.00004C3.2928 14.6673 2.61452 14.3864 2.11442 13.8863C1.61433 13.3862 1.33337 12.7079 1.33337 12.0007V4.00065Z",
    stroke: "#A7A7A7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 7.33333C6.58714 7.33333 7.33333 6.58714 7.33333 5.66667C7.33333 4.74619 6.58714 4 5.66667 4C4.74619 4 4 4.74619 4 5.66667C4 6.58714 4.74619 7.33333 5.66667 7.33333Z",
    stroke: "#A7A7A7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.684 8.41485L4 14.6675H12.0887C12.7724 14.6675 13.4281 14.3959 13.9116 13.9124C14.3951 13.429 14.6667 12.7732 14.6667 12.0895V12.0008C14.6667 11.6902 14.55 11.5708 14.34 11.3408L11.6533 8.41085C11.5281 8.27426 11.3758 8.16527 11.2061 8.09083C11.0364 8.01639 10.8531 7.97814 10.6678 7.97852C10.4825 7.97889 10.2993 8.01789 10.1299 8.09302C9.96053 8.16814 9.80866 8.27775 9.684 8.41485Z",
    stroke: "#A7A7A7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatImage);
export default __webpack_public_path__ + "static/media/chat-image.6a129c093edcde017e7b1eb9388e24c1.svg";
export { ForwardRef as ReactComponent };